module.exports = __webpack_public_path__ + "static/wood-background-592885a46e23413d572641f1f8493cd0.png";